import styled from 'styled-components';
import { ColorSelectStyled } from '../ColorSelectStyled';
import { rem } from 'polished';

export const ColorSelectStyledAP = styled(ColorSelectStyled)``;
